import type { ReactNode } from 'react';

export interface ModalBaseProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  width?: number;
}

export function ModalBase({
  open,
  onClose,
  title,
  children,
  footer,
  width = 560,
}: ModalBaseProps): React.JSX.Element | null {
  if (!open) return null;
  // .modal-back é o backdrop; o mockup (modals-3.jsx:9-23) fecha no clique no
  // backdrop e usa stopPropagation no .modal. Aqui (padrão DrawerBase) o backdrop
  // fecha só no clique direto (e.target === e.currentTarget) + Escape; o .modal
  // mantém role="dialog". Render/classes idênticos ao mockup; a11y preservada.
  return (
    <div
      className="modal-back"
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Escape') onClose();
      }}
    >
      <div className="modal" style={{ width }} role="dialog" aria-modal="true" aria-label={title}>
        <header className="modal__head">
          <h2 className="modal__title">{title}</h2>
          <button
            type="button"
            className="btn btn--ghost btn--sm btn--icon"
            onClick={onClose}
            aria-label="Fechar"
          >
            ×
          </button>
        </header>
        <div className="modal__body">{children}</div>
        {footer !== undefined && <footer className="modal__foot">{footer}</footer>}
      </div>
    </div>
  );
}
